export default function DeleteStaffModal({
  isOpen,
  staff,
  loading,
  error,
  onClose,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-start justify-between">
          <h2 className="text-xl font-semibold text-slate-900">
            Permanently Delete Staff
          </h2>

          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-2xl leading-none text-slate-500 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        <p className="mt-3 text-sm leading-6 text-slate-600">
          You are about to permanently delete{" "}
          <span className="font-semibold text-slate-900">
            {staff?.first_name} {staff?.last_name}
          </span>
          .
        </p>

        <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-700">
          <p className="font-semibold mb-1">
            This will permanently remove all attendance and document records of the staff.
          </p>

      

          <p className="mt-3 font-semibold">
            This action cannot be undone.
          </p>
        </div>

        {error ? (
          <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
            {error}
          </div>
        ) : null}

        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="rounded-xl bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Deleting..." : "Delete Permanently"}
          </button>
        </div>
      </div>
    </div>
  );
}